import * as React from 'react';
import {
    Stack,
    Button,
    Typography,
} from '@mui/material';
import {
    TextInput,
    required,
    SelectInput,
    ReferenceInput,
    BooleanInput,
    PasswordInput
} from 'react-admin';
import { Role } from '@/types';

export const UserInputs = ({
    isEditPasswordMode = true,
    setEditPasswordMode = () => {},
    isEditMode = false
}: {
    isEditPasswordMode?: boolean;
    setEditPasswordMode?: (value: boolean) => void;
    isEditMode?: boolean;
}) => {
    const equalToPassword = (value: any, allValues: { [key: string]: any }) => {
        if (value !== allValues.password) {
            return 'The two passwords must match';
        }
    }

    return (
        <Stack flex={1} gap={1} sx={{ width: '100%', maxWidth: 600 }}>
            <Typography variant="h6">Basic Info</Typography>
            <TextInput
                source="name"
                validate={required()}
                helperText={false}
            />
            <TextInput
                type="email"
                label="Email"
                source="email"
                validate={required()}
                helperText={false}
            />
            <BooleanInput label="Active" source="is_active" />
            <BooleanInput label="Super user" source="is_superuser" />
            <BooleanInput label="Can sign contracts" source="can_sign" />
            <ReferenceInput
                reference="roles"
                source="role_id"
            >
                <SelectInput
                    helperText={false}
                    label="Select Role"
                    optionText={roleOptionRender}
                    validate={required()}
                />
            </ReferenceInput>
            <br></br>
            {isEditMode && !isEditPasswordMode && (
                <>
                    <Button
                        variant="outlined"
                        onClick={() => setEditPasswordMode(!isEditPasswordMode)}
                    >
                        Change password
                    </Button>
                </>
            )}
            {(!isEditMode || (isEditMode && isEditPasswordMode)) && (
                <Stack gap={2}>
                    <PasswordInput source="password" />
                    <PasswordInput source="confirm_password" validate={equalToPassword} />
                    {isEditMode && (
                        <Button
                            variant="outlined"
                            onClick={() => setEditPasswordMode(!isEditPasswordMode)}
                        >
                            Cancel
                        </Button>
                    )}
                </Stack>
            )}
        </Stack>
    );
};
const roleOptionRender = (choice: Role) =>
    `${choice.name}`;